// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../../shared/src/IOUtils.bs.js");
var ReactIO = require("../../../../shared/src/ReactIO.bs.js");
var DomUtils = require("../../../../shared/src/DomUtils.bs.js");
var Reselect = require("../../../../shared/src/bindings/Reselect.bs.js");
var Formality = require("re-formality/src/Formality.bs.js");
var MathUtils = require("../../../../shared/src/MathUtils.bs.js");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var ReactUtils = require("../../../../shared/src/ReactUtils.bs.js");
var Relude_Int = require("relude/src/Relude_Int.bs.js");
var Relude_Map = require("relude/src/Relude_Map.bs.js");
var Relude_Set = require("relude/src/Relude_Set.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../../../../shared-browser/src/BrowserStyle.bs.js");
var Relude_Array = require("relude/src/Relude_Array.bs.js");
var Relude_Float = require("relude/src/Relude_Float.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");
var Relude_Result = require("relude/src/Relude_Result.bs.js");
var Relude_String = require("relude/src/Relude_String.bs.js");
var Relude_Globals = require("relude/src/Relude_Globals.bs.js");
var Relude_Js_Promise = require("relude/src/js/Relude_Js_Promise.bs.js");
var Formality__Debouncer = require("re-formality/src/Formality__Debouncer.bs.js");
var CommonTypes_ShiftType = require("../../../../shared/src/types/CommonTypes_ShiftType.bs.js");
var BrowserComponents_Card = require("../../../../shared-browser/src/components/BrowserComponents_Card.bs.js");
var BrowserComponents_Icon = require("../../../../shared-browser/src/components/BrowserComponents_Icon.bs.js");
var BrowserComponents_Text = require("../../../../shared-browser/src/components/BrowserComponents_Text.bs.js");
var Formality__ReactUpdate = require("re-formality/src/Formality__ReactUpdate.bs.js");
var BrowserComponents_Field = require("../../../../shared-browser/src/components/BrowserComponents_Field.bs.js");
var BrowserComponents_Input = require("../../../../shared-browser/src/components/BrowserComponents_Input.bs.js");
var BrowserComponents_Modal = require("../../../../shared-browser/src/components/BrowserComponents_Modal.bs.js");
var BrowserComponents_Button = require("../../../../shared-browser/src/components/BrowserComponents_Button.bs.js");
var BrowserComponents_Spacer = require("../../../../shared-browser/src/components/BrowserComponents_Spacer.bs.js");
var BrowserComponents_Switch = require("../../../../shared-browser/src/components/BrowserComponents_Switch.bs.js");
var BrowserComponents_Counter = require("../../../../shared-browser/src/components/BrowserComponents_Counter.bs.js");
var BrowserComponents_FlexRow = require("../../../../shared-browser/src/components/BrowserComponents_FlexRow.bs.js");
var BrowserComponents_Subtext = require("../../../../shared-browser/src/components/BrowserComponents_Subtext.bs.js");
var BrowserComponents_FlexColumn = require("../../../../shared-browser/src/components/BrowserComponents_FlexColumn.bs.js");
var WebComponents_PostAShiftForm = require("../../components/WebComponents_PostAShiftForm.bs.js");
var BrowserComponents_RadioButton = require("../../../../shared-browser/src/components/BrowserComponents_RadioButton.bs.js");
var CommonTypes_ShiftType_Category = require("../../../../shared/src/types/CommonTypes_ShiftType_Category.bs.js");
var CommonTypes_Shift_TipsPayoutType = require("../../../../shared/src/types/CommonTypes_Shift_TipsPayoutType.bs.js");
var BrowserComponents_ValidationError = require("../../../../shared-browser/src/components/BrowserComponents_ValidationError.bs.js");
var CommonTypes_Business_RequestableWorker = require("../../../../shared/src/types/business/CommonTypes_Business_RequestableWorker.bs.js");

var ResultWithStringError = Relude_Result.WithError({});

function arg(param) {
  return BrowserStyle.withFont(param, /* OpenSans */1, /* Large */4, /* Semibold */1);
}

var container = Curry._1(BrowserStyle.style, Curry._1(arg(undefined), {
          hd: BrowserStyle.alignSelf(BrowserStyle.center),
          tl: {
            hd: BrowserStyle.display(BrowserStyle.flexBox),
            tl: {
              hd: BrowserStyle.flexDirection(BrowserStyle.column),
              tl: {
                hd: BrowserStyle.minWidth(BrowserStyle.rem(30.0)),
                tl: {
                  hd: BrowserStyle.mobileMedia({
                        hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
                        tl: /* [] */0
                      }),
                  tl: {
                    hd: BrowserStyle.padding2(BrowserStyle.Spacing.xSmall, BrowserStyle.Spacing.large),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }));

var section = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.borderBottom(BrowserStyle.rem(0.0625), BrowserStyle.solid, {
            TAG: /* Grey */2,
            _0: /* Lightest */4
          }),
      tl: {
        hd: BrowserStyle.lastChild({
              hd: BrowserStyle.borderBottom(BrowserStyle.zero, BrowserStyle.none, /* Transparent */2),
              tl: {
                hd: BrowserStyle.color({
                      TAG: /* Teal */6,
                      _0: /* Medium */2
                    }),
                tl: /* [] */0
              }
            }),
        tl: {
          hd: BrowserStyle.padding2(BrowserStyle.Spacing.large, BrowserStyle.zero),
          tl: /* [] */0
        }
      }
    });

var sectionRow = Curry._1(BrowserStyle.merge, {
      hd: section,
      tl: {
        hd: Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.alignItems(BrowserStyle.center),
              tl: {
                hd: BrowserStyle.justifyContent(BrowserStyle.spaceBetween),
                tl: /* [] */0
              }
            }),
        tl: /* [] */0
      }
    });

var rightSection = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: /* [] */0
    });

function tipsPayoutMethodTitle(isErrored) {
  return Curry._1(BrowserStyle.style, isErrored ? ({
                  hd: BrowserStyle.color({
                        TAG: /* Red */5,
                        _0: /* Medium */2
                      }),
                  tl: /* [] */0
                }) : /* [] */0);
}

var tipsSwitchLabel = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flex({
            NAME: "num",
            VAL: 1.0
          }),
      tl: /* [] */0
    });

var tipsValidationError = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, undefined, undefined)(/* [] */0));

var inputBox = Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Large */4, undefined)({
          hd: BrowserStyle.border(BrowserStyle.rem(0.125), BrowserStyle.solid, {
                TAG: /* Grey */2,
                _0: /* Lightest */4
              }),
          tl: {
            hd: BrowserStyle.borderRadius(BrowserStyle.Input.borderRadius),
            tl: {
              hd: BrowserStyle.marginLeft(BrowserStyle.rem(0.4375)),
              tl: {
                hd: BrowserStyle.outline(BrowserStyle.zero, BrowserStyle.none, /* Transparent */2),
                tl: {
                  hd: BrowserStyle.padding2(BrowserStyle.rem(0.375), BrowserStyle.rem(0.75)),
                  tl: {
                    hd: BrowserStyle.textAlign("right"),
                    tl: {
                      hd: BrowserStyle.width(BrowserStyle.rem(4.5)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }
          }
        }));

var Styles = {
  container: container,
  section: section,
  sectionRow: sectionRow,
  rightSection: rightSection,
  tipsPayoutMethodTitle: tipsPayoutMethodTitle,
  tipsSwitchLabel: tipsSwitchLabel,
  tipsValidationError: tipsValidationError,
  inputBox: inputBox
};

function getServiceFee(hourlyRate, markupRate) {
  return hourlyRate * markupRate;
}

function getTotalCostPerWorker(hourlyRate, markupRate) {
  return hourlyRate + hourlyRate * markupRate;
}

function WebContainers_PostAShift_ShiftType$HourlyRate(Props) {
  var markupRate = Props.markupRate;
  var hourlyRate = Props.hourlyRate;
  var onChangeRate = Props.onChangeRate;
  var onChangeTipsPayoutType = Props.onChangeTipsPayoutType;
  var onBlur = Props.onBlur;
  var testId = Props.testId;
  var tipsPaidByQwickMarkup = Props.tipsPaidByQwickMarkup;
  var tipsPayoutType = Props.tipsPayoutType;
  var tipsPayoutTypeResult = Props.tipsPayoutTypeResult;
  var match = ReactIO.useState(function (param) {
        return Relude_Option.fold("", Relude_Float.toString, hourlyRate);
      });
  var onChangeInternal = match[1];
  var onChange = function (hourlyRate) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(onChangeRate, Relude_String.toFloat(hourlyRate));
                }), Curry._1(onChangeInternal, hourlyRate));
  };
  var tmp;
  var exit = 0;
  if (tipsPayoutType !== undefined && !(typeof tipsPayoutType === "number" && tipsPayoutType !== 0)) {
    tmp = null;
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
              size: /* Medium */4
            }), React.createElement(BrowserComponents_Text.make, {
              className: tipsPayoutMethodTitle(Relude_Option.isSome(Curry._2(Relude_Option.flatMap, Relude_Result.getError, tipsPayoutTypeResult))),
              children: "What method are you paying tips?"
            }), React.createElement(BrowserComponents_Spacer.make, {
              size: /* Medium */4
            }), React.createElement(BrowserComponents_RadioButton.make, {
              isSelected: Relude_Option.fold(false, Curry._1(CommonTypes_Shift_TipsPayoutType.eq, /* TipsPaidInCash */2), tipsPayoutType),
              onClick: (function (param) {
                  return Curry._1(onChangeTipsPayoutType, Relude_Option.pure(/* TipsPaidInCash */2));
                }),
              title: "In cash"
            }), React.createElement(BrowserComponents_Spacer.make, {
              size: /* Medium */4
            }), React.createElement(BrowserComponents_RadioButton.make, {
              isSelected: Relude_Option.fold(false, Curry._1(CommonTypes_Shift_TipsPayoutType.eq, /* TipsPaidByQwick */1), tipsPayoutType),
              onClick: (function (param) {
                  return Curry._1(onChangeTipsPayoutType, Relude_Option.pure(/* TipsPaidByQwick */1));
                }),
              subtitle: "There is a " + (MathUtils.formatPercent(tipsPaidByQwickMarkup) + " fee on tips paid though the Qwick App."),
              title: "Through the Qwick app"
            }), Relude_Option.fold(null, (function (message) {
                return React.createElement(BrowserComponents_Field.ErrorMessage.make, {
                            message: message
                          });
              }), Curry._2(Relude_Option.flatMap, Relude_Result.getError, tipsPayoutTypeResult)));
  }
  var tmp$1 = {
    className: inputBox,
    value: {
      TAG: /* Text */7,
      _0: {
        onChange: onChange,
        value: match[0]
      }
    }
  };
  if (onBlur !== undefined) {
    tmp$1.onBlur = Caml_option.valFromOption(onBlur);
  }
  var tmp$2 = {
    children: React.createElement(BrowserComponents_Input.BaseStatefulStyleType.make, tmp$1)
  };
  if (testId !== undefined) {
    tmp$2.id = Caml_option.valFromOption(testId);
  }
  return React.createElement(BrowserComponents_Card.make, {
              className: container,
              children: null
            }, React.createElement(BrowserComponents_FlexColumn.make, {
                  className: section,
                  children: null
                }, React.createElement(BrowserComponents_FlexRow.make, {
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          className: tipsSwitchLabel,
                          children: "Will the Professional be earning tips?"
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Medium */4
                        }), React.createElement(BrowserComponents_Switch.make, {
                          onValueChange: (function (param) {
                              return Relude_Globals.$great$great((function (param) {
                                            if (param) {
                                              return ;
                                            } else {
                                              return Relude_Option.pure(/* NoTips */0);
                                            }
                                          }), onChangeTipsPayoutType, param);
                            }),
                          value: tipsPayoutType !== undefined ? (
                              typeof tipsPayoutType === "number" ? tipsPayoutType !== 0 : false
                            ) : true
                        })), tmp), React.createElement(BrowserComponents_FlexRow.make, {
                  className: sectionRow,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      children: "Hourly Rate"
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: rightSection,
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          children: "$"
                        }), React.createElement(ReactUtils.WithTestId.make, tmp$2), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Small */3
                        }), React.createElement(BrowserComponents_Text.make, {
                          children: "USD"
                        }))), React.createElement(BrowserComponents_FlexRow.make, {
                  className: sectionRow,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      children: "Qwick Service Fee (" + (MathUtils.formatPercent(markupRate) + ")")
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: rightSection,
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          children: MathUtils.formatMoney(Relude_Option.getOrElse(0.0, hourlyRate) * markupRate)
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement(BrowserComponents_Text.make, {
                          children: "USD"
                        }))), React.createElement(BrowserComponents_FlexRow.make, {
                  className: sectionRow,
                  children: null
                }, React.createElement(BrowserComponents_Text.make, {
                      children: "Total Cost Per Worker"
                    }), React.createElement(BrowserComponents_FlexRow.make, {
                      className: rightSection,
                      children: null
                    }, React.createElement(BrowserComponents_Text.make, {
                          children: MathUtils.formatMoney(getTotalCostPerWorker(Relude_Option.getOrElse(0.0, hourlyRate), markupRate))
                        }), React.createElement(BrowserComponents_Spacer.make, {
                          size: /* Large */5
                        }), React.createElement(BrowserComponents_Text.make, {
                          children: "USD"
                        }))));
}

var HourlyRate = {
  Styles: Styles,
  getServiceFee: getServiceFee,
  getTotalCostPerWorker: getTotalCostPerWorker,
  make: WebContainers_PostAShift_ShiftType$HourlyRate
};

function descText(isValidationMessage) {
  return Curry._1(BrowserStyle.style, BrowserStyle.withFont(undefined, undefined, /* Medium */3, undefined)({
                  hd: BrowserStyle.color(isValidationMessage ? ({
                            TAG: /* Red */5,
                            _0: /* Medium */2
                          }) : ({
                            TAG: /* Grey */2,
                            _0: /* Medium */2
                          })),
                  tl: {
                    hd: BrowserStyle.minHeight(BrowserStyle.rem(3.0)),
                    tl: {
                      hd: BrowserStyle.textAlign("center"),
                      tl: /* [] */0
                    }
                  }
                }));
}

var shiftCategoriesButtonContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var shiftTypesButtonContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.stretch),
      tl: {
        hd: BrowserStyle.justifyContent(BrowserStyle.center),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flexDirection(BrowserStyle.column),
                tl: {
                  hd: BrowserStyle.justifyContent(BrowserStyle.stretch),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var counter = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.margin(BrowserStyle.zero),
        tl: /* [] */0
      }
    });

var requestProfessionalsButton = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: /* [] */0
    });

var professionalSelectSection = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexWrap(BrowserStyle.wrap),
      tl: {
        hd: BrowserStyle.maxHeight(BrowserStyle.rem(14.0)),
        tl: {
          hd: BrowserStyle.overflowY("scroll"),
          tl: {
            hd: BrowserStyle.overflowX("hidden"),
            tl: /* [] */0
          }
        }
      }
    });

var professionalSelector = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.margin(BrowserStyle.Spacing.xSmall),
      tl: /* [] */0
    });

var lowRateHeader = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: /* [] */0
    });

var error = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignSelf(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.textAlign(BrowserStyle.center),
        tl: /* [] */0
      }
    });

var Styles$1 = {
  descText: descText,
  shiftCategoriesButtonContainer: shiftCategoriesButtonContainer,
  shiftTypesButtonContainer: shiftTypesButtonContainer,
  counter: counter,
  requestProfessionalsButton: requestProfessionalsButton,
  professionalSelectSection: professionalSelectSection,
  professionalSelector: professionalSelector,
  lowRateHeader: lowRateHeader,
  error: error
};

var validators_tipsPayoutType = {
  strategy: /* OnSubmit */4,
  validate: (function (param, _metadata) {
      return Relude_Result.fromOption("You must choose a payment method", param.tipsPayoutType);
    })
};

var validators_selectedShiftType = {
  strategy: /* OnSubmit */4,
  validate: (function (param, _metadata) {
      return Relude_Result.fromOption("Must select a type of shift", param.selectedShiftType);
    })
};

var validators_numberOfWorkers = {
  strategy: /* OnFirstBlur */0,
  validate: (function (param, _metadata) {
      var numberOfWorkers = param.numberOfWorkers;
      if (Curry._2(Relude_Int.OrdNamed.greaterThan, 0, numberOfWorkers)) {
        return Relude_Result.ok(numberOfWorkers);
      } else {
        return Relude_Result.error("Must have at least 1 worker");
      }
    })
};

var validators_hourlyRate = {
  strategy: /* OnFirstChange */1,
  validate: (function (param, _metadata) {
      return Curry._2(ResultWithStringError.mapTuple2, (function (hourlyRate, shiftTypeId) {
                    return {
                            averageRateCents: 0,
                            hourlyRate: hourlyRate,
                            shiftTypeId: shiftTypeId
                          };
                  }), [
                  Relude_Result.fromOption("Please enter an hourly rate", Relude_Float.fromString(param.hourlyRate)),
                  Relude_Result.fromOption("Must also select a type of shift", Relude_Option.map((function (param) {
                              return param.id;
                            }), param.selectedShiftType))
                ]);
    }),
  validateAsync: Formality__Debouncer.make(700, (function (param) {
          var dispatch = param[2];
          var value = param[0];
          var validate = function (param, param$1) {
            var shiftTypeId = param.shiftTypeId;
            var hourlyRate = param.hourlyRate;
            return Relude_Js_Promise.fromIO(Relude_IO.summonError(Relude_IO.flatMap((function (param) {
                                  var minimumRateCents = param.minimumRateCents;
                                  var category = param.category;
                                  if (Curry._2(Relude_Int.OrdNamed.greaterThanOrEq, minimumRateCents, Relude_Float.roundAsInt(hourlyRate * 100.0))) {
                                    return Relude_IO.pure({
                                                averageRateCents: param.averageRateCents,
                                                hourlyRate: hourlyRate,
                                                shiftTypeId: shiftTypeId
                                              });
                                  } else {
                                    return Relude_IO.$$throw(typeof category === "number" ? (
                                                  category !== 1 ? (
                                                      category !== 0 ? "Data shows that the increased rate for high quality Professionals to fill this shift type is " + (MathUtils.formatCentsToMoney(minimumRateCents) + " right now") : "Data shows that a minimum rate for high quality Professionals to fill this shift type is " + MathUtils.formatCentsToMoney(minimumRateCents)
                                                    ) : "Last Minute Shift: Data shows that a minimum rate for high quality Professionals to fill this shift type is " + MathUtils.formatCentsToMoney(minimumRateCents)
                                                ) : "Our data shows that this shift rate is too low and won't be able to be filled");
                                  }
                                }), Curry._2(Relude_IO.mapError, (function (param) {
                                      return "Could not validate minimum hourly rate for this shift type";
                                    }), Curry._1(param$1.fetchMinHourlyRate, shiftTypeId)))));
          };
          return Formality.Async.validateAsyncWithMetadata(value, param[1], validate, (function (res) {
                        return Curry._1(dispatch, {
                                    TAG: /* ApplyAsyncResultForHourlyRateField */4,
                                    _0: value,
                                    _1: res
                                  });
                      }));
        })),
  eq: (function (param, param$1) {
      if (Relude_Int.eq(param.averageRateCents, param$1.averageRateCents) && Relude_Float.eq(param.hourlyRate, param$1.hourlyRate)) {
        return Curry._2(CommonTypes_ShiftType.Id.eq, param.shiftTypeId, param$1.shiftTypeId);
      } else {
        return false;
      }
    })
};

var validators = {
  tipsPayoutType: validators_tipsPayoutType,
  selectedShiftType: validators_selectedShiftType,
  numberOfWorkers: validators_numberOfWorkers,
  hourlyRate: validators_hourlyRate
};

function initialInput(basicInfo) {
  return {
          hourlyRate: Relude_Option.fold("", (function (param) {
                  return Relude_Float.toString(param.hourlyRate);
                }), basicInfo),
          numberOfWorkers: Relude_Option.fold(1, (function (param) {
                  return param.numberOfWorkers;
                }), basicInfo),
          selectedShiftType: Relude_Option.map((function (param) {
                  return param.shiftType;
                }), basicInfo),
          tipsPayoutType: Relude_Option.pure(Relude_Option.fold(/* NoTips */0, (function (param) {
                      return param.tipsPayoutType;
                    }), basicInfo))
        };
}

function toNewShiftBasicInfo(requestedWorkers, param) {
  return {
          hourlyRate: param.hourlyRate.hourlyRate,
          numberOfWorkers: param.numberOfWorkers,
          requestedWorkers: requestedWorkers,
          shiftType: param.selectedShiftType,
          tipsPayoutType: param.tipsPayoutType
        };
}

function initialFieldsStatuses(_input) {
  return {
          tipsPayoutType: /* Pristine */0,
          selectedShiftType: /* Pristine */0,
          numberOfWorkers: /* Pristine */0,
          hourlyRate: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: {
            tipsPayoutType: /* Pristine */0,
            selectedShiftType: /* Pristine */0,
            numberOfWorkers: /* Pristine */0,
            hourlyRate: /* Pristine */0
          },
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  var match = fieldsStatuses.tipsPayoutType;
  var match_0 = match ? match._0 : Curry._2(validators.tipsPayoutType.validate, input, metadata);
  var match$1 = fieldsStatuses.selectedShiftType;
  var match_0$1 = match$1 ? match$1._0 : Curry._2(validators.selectedShiftType.validate, input, metadata);
  var match$2 = fieldsStatuses.numberOfWorkers;
  var match_0$2 = match$2 ? match$2._0 : Curry._2(validators.numberOfWorkers.validate, input, metadata);
  var value = fieldsStatuses.hourlyRate;
  var tmp;
  tmp = typeof value === "number" ? ({
        NAME: "Result",
        VAL: Curry._2(validators.hourlyRate.validate, input, metadata)
      }) : (
      value.TAG === /* Dirty */0 ? ({
            NAME: "Result",
            VAL: value._0
          }) : ({
            NAME: "Validating",
            VAL: value._0
          })
    );
  var tipsPayoutTypeResult = match_0;
  var exit = 0;
  var hourlyRateResult = tmp;
  if (typeof hourlyRateResult === "string") {
    exit = 2;
  } else {
    if (hourlyRateResult.NAME === "Validating") {
      return {
              TAG: /* Validating */2,
              fieldsStatuses: {
                tipsPayoutType: /* Dirty */{
                  _0: tipsPayoutTypeResult,
                  _1: /* Shown */0
                },
                selectedShiftType: /* Dirty */{
                  _0: match_0$1,
                  _1: /* Shown */0
                },
                numberOfWorkers: /* Dirty */{
                  _0: match_0$2,
                  _1: /* Shown */0
                },
                hourlyRate: hourlyRateResult.NAME === "Result" ? ({
                      TAG: /* Dirty */0,
                      _0: hourlyRateResult.VAL,
                      _1: /* Shown */0
                    }) : ({
                      TAG: /* Validating */1,
                      _0: hourlyRateResult.VAL
                    })
              },
              collectionsStatuses: undefined
            };
    }
    exit = 2;
  }
  if (exit === 2 && tipsPayoutTypeResult.TAG === /* Ok */0) {
    var selectedShiftTypeResult = match_0$1;
    if (selectedShiftTypeResult.TAG === /* Ok */0) {
      var numberOfWorkersResult = match_0$2;
      if (numberOfWorkersResult.TAG === /* Ok */0) {
        var match$3 = tmp;
        if (typeof match$3 !== "string" && match$3.NAME === "Result") {
          var hourlyRateResult$1 = match$3.VAL;
          if (hourlyRateResult$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Valid */0,
                    output: {
                      hourlyRate: hourlyRateResult$1._0,
                      numberOfWorkers: numberOfWorkersResult._0,
                      selectedShiftType: selectedShiftTypeResult._0,
                      tipsPayoutType: tipsPayoutTypeResult._0
                    },
                    fieldsStatuses: {
                      tipsPayoutType: /* Dirty */{
                        _0: tipsPayoutTypeResult,
                        _1: /* Shown */0
                      },
                      selectedShiftType: /* Dirty */{
                        _0: selectedShiftTypeResult,
                        _1: /* Shown */0
                      },
                      numberOfWorkers: /* Dirty */{
                        _0: numberOfWorkersResult,
                        _1: /* Shown */0
                      },
                      hourlyRate: {
                        TAG: /* Dirty */0,
                        _0: hourlyRateResult$1,
                        _1: /* Shown */0
                      }
                    },
                    collectionsStatuses: undefined
                  };
          }
          
        }
        
      }
      
    }
    
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            tipsPayoutType: /* Dirty */{
              _0: tipsPayoutTypeResult,
              _1: /* Shown */0
            },
            selectedShiftType: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            numberOfWorkers: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            hourlyRate: {
              TAG: /* Dirty */0,
              _0: tmp.VAL,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, metadata, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurTipsPayoutTypeField */0 :
                  var result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.tipsPayoutType, validators_tipsPayoutType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  tipsPayoutType: status,
                                  selectedShiftType: init.selectedShiftType,
                                  numberOfWorkers: init.numberOfWorkers,
                                  hourlyRate: init.hourlyRate
                                };
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSelectedShiftTypeField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.selectedShiftType, validators_selectedShiftType, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  tipsPayoutType: init.tipsPayoutType,
                                  selectedShiftType: status,
                                  numberOfWorkers: init.numberOfWorkers,
                                  hourlyRate: init.hourlyRate
                                };
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurNumberOfWorkersField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.numberOfWorkers, validators_numberOfWorkers, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  tipsPayoutType: init.tipsPayoutType,
                                  selectedShiftType: init.selectedShiftType,
                                  numberOfWorkers: status,
                                  hourlyRate: init.hourlyRate
                                };
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHourlyRateField */3 :
                  var result$3 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.hourlyRate, validators_hourlyRate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  tipsPayoutType: init.tipsPayoutType,
                                  selectedShiftType: init.selectedShiftType,
                                  numberOfWorkers: init.numberOfWorkers,
                                  hourlyRate: status
                                };
                        }));
                  if (result$3 === undefined) {
                    return /* NoUpdate */0;
                  }
                  var value = result$3.hourlyRate;
                  if (typeof value !== "number" && value.TAG !== /* Dirty */0) {
                    var value$1 = value._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_hourlyRate.validateAsync, [
                                            value$1,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: result$3,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
                  break;
              case /* Submit */4 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses, metadata);
                  switch (match$1.TAG | 0) {
                    case /* Valid */0 :
                        var output = match$1.output;
                        var error = state.formStatus;
                        var tmp;
                        tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : error._0;
                        return {
                                TAG: /* UpdateWithSideEffects */1,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: {
                                    TAG: /* Submitting */0,
                                    _0: tmp
                                  },
                                  submissionStatus: /* AttemptedToSubmit */1
                                },
                                _1: (function (param) {
                                    var dispatch = param.dispatch;
                                    return Curry._2(onSubmit, output, {
                                                notifyOnSuccess: (function (input) {
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetSubmittedStatus */5,
                                                                _0: input
                                                              });
                                                  }),
                                                notifyOnFailure: (function (error) {
                                                    return Curry._1(dispatch, {
                                                                TAG: /* SetSubmissionFailedStatus */6,
                                                                _0: error
                                                              });
                                                  }),
                                                reset: (function (param) {
                                                    return Curry._1(dispatch, /* Reset */7);
                                                  }),
                                                dismissSubmissionResult: (function (param) {
                                                    return Curry._1(dispatch, /* DismissSubmissionResult */6);
                                                  })
                                              });
                                  })
                              };
                    case /* Invalid */1 :
                        return {
                                TAG: /* Update */0,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: /* Editing */0,
                                  submissionStatus: /* AttemptedToSubmit */1
                                }
                              };
                    case /* Validating */2 :
                        return {
                                TAG: /* Update */0,
                                _0: {
                                  input: state.input,
                                  fieldsStatuses: match$1.fieldsStatuses,
                                  collectionsStatuses: match$1.collectionsStatuses,
                                  formStatus: state.formStatus,
                                  submissionStatus: state.submissionStatus
                                }
                              };
                    
                  }
                  break;
              case /* DismissSubmissionError */5 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */6 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */7 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateTipsPayoutTypeField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.tipsPayoutType, state.submissionStatus, validators_tipsPayoutType, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            tipsPayoutType: status,
                                            selectedShiftType: init.selectedShiftType,
                                            numberOfWorkers: init.numberOfWorkers,
                                            hourlyRate: init.hourlyRate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSelectedShiftTypeField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$4 = Formality.Async.validateDependentFieldOnChangeWithMetadata(nextInput$1, metadata, nextFieldsStatuses.contents.hourlyRate, validators_hourlyRate, (function (status) {
                          var init = nextFieldsStatuses.contents;
                          return {
                                  tipsPayoutType: init.tipsPayoutType,
                                  selectedShiftType: init.selectedShiftType,
                                  numberOfWorkers: init.numberOfWorkers,
                                  hourlyRate: status
                                };
                        }));
                  if (result$4 !== undefined) {
                    nextFieldsStatuses.contents = result$4;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, nextFieldsStatuses.contents.selectedShiftType, state.submissionStatus, validators_selectedShiftType, (function (status) {
                                    var init = nextFieldsStatuses.contents;
                                    return {
                                            tipsPayoutType: init.tipsPayoutType,
                                            selectedShiftType: status,
                                            numberOfWorkers: init.numberOfWorkers,
                                            hourlyRate: init.hourlyRate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateNumberOfWorkersField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$2, metadata, state.fieldsStatuses.numberOfWorkers, state.submissionStatus, validators_numberOfWorkers, (function (status) {
                                    var init = state.fieldsStatuses;
                                    return {
                                            tipsPayoutType: init.tipsPayoutType,
                                            selectedShiftType: init.selectedShiftType,
                                            numberOfWorkers: status,
                                            hourlyRate: init.hourlyRate
                                          };
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHourlyRateField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$3, metadata, state.fieldsStatuses.hourlyRate, state.submissionStatus, validators_hourlyRate, (function (status) {
                          var init = state.fieldsStatuses;
                          return {
                                  tipsPayoutType: init.tipsPayoutType,
                                  selectedShiftType: init.selectedShiftType,
                                  numberOfWorkers: init.numberOfWorkers,
                                  hourlyRate: status
                                };
                        }));
                  var value$2 = nextFieldsStatuses$1.hourlyRate;
                  if (typeof value$2 !== "number" && value$2.TAG !== /* Dirty */0) {
                    var value$3 = value$2._0;
                    return {
                            TAG: /* UpdateWithSideEffects */1,
                            _0: {
                              input: nextInput$3,
                              fieldsStatuses: nextFieldsStatuses$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            },
                            _1: (function (param) {
                                return Curry._1(validators_hourlyRate.validateAsync, [
                                            value$3,
                                            metadata,
                                            param.dispatch
                                          ]);
                              })
                          };
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: nextFieldsStatuses$1,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* ApplyAsyncResultForHourlyRateField */4 :
                  var validator = validators_hourlyRate;
                  var x = state.fieldsStatuses.hourlyRate;
                  if (typeof x === "number") {
                    return /* NoUpdate */0;
                  }
                  if (x.TAG === /* Dirty */0) {
                    return /* NoUpdate */0;
                  }
                  if (!Curry._2(validator.eq, x._0, action._0)) {
                    return /* NoUpdate */0;
                  }
                  var init = state.fieldsStatuses;
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: {
                              tipsPayoutType: init.tipsPayoutType,
                              selectedShiftType: init.selectedShiftType,
                              numberOfWorkers: init.numberOfWorkers,
                              hourlyRate: {
                                TAG: /* Dirty */0,
                                _0: action._1,
                                _1: /* Shown */0
                              }
                            },
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */5 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: {
                                tipsPayoutType: /* Pristine */0,
                                selectedShiftType: /* Pristine */0,
                                numberOfWorkers: /* Pristine */0,
                                hourlyRate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: {
                                tipsPayoutType: /* Pristine */0,
                                selectedShiftType: /* Pristine */0,
                                numberOfWorkers: /* Pristine */0,
                                hourlyRate: /* Pristine */0
                              },
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */6 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */7 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Curry._1(map, error$2)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateTipsPayoutType: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateTipsPayoutTypeField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSelectedShiftType: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSelectedShiftTypeField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateNumberOfWorkers: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateNumberOfWorkersField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateHourlyRate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHourlyRateField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurTipsPayoutType: (function (param) {
              return Curry._1(dispatch, /* BlurTipsPayoutTypeField */0);
            }),
          blurSelectedShiftType: (function (param) {
              return Curry._1(dispatch, /* BlurSelectedShiftTypeField */1);
            }),
          blurNumberOfWorkers: (function (param) {
              return Curry._1(dispatch, /* BlurNumberOfWorkersField */2);
            }),
          blurHourlyRate: (function (param) {
              return Curry._1(dispatch, /* BlurHourlyRateField */3);
            }),
          tipsPayoutTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.tipsPayoutType),
          selectedShiftTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.selectedShiftType),
          numberOfWorkersResult: Formality.exposeFieldResult(state.fieldsStatuses.numberOfWorkers),
          hourlyRateResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.hourlyRate),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              if (match.tipsPayoutType || match.selectedShiftType || match.numberOfWorkers || typeof match.hourlyRate !== "number") {
                return true;
              } else {
                return false;
              }
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses, metadata);
              switch (match.TAG | 0) {
                case /* Valid */0 :
                    return true;
                case /* Invalid */1 :
                    return false;
                case /* Validating */2 :
                    return ;
                
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */4);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */5);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */6);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */7,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */7);
            })
        };
}

var FormFields = {
  debounceInterval: 700,
  validators: validators,
  initialInput: initialInput,
  toNewShiftBasicInfo: toNewShiftBasicInfo,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function arg$1(param, param$1, param$2) {
  return BrowserStyle.withFont(param, param$1, param$2, /* Bold */2);
}

var selector = Curry._1(BrowserStyle.style, Curry._1(arg$1(undefined, undefined, undefined), {
          hd: BrowserStyle.margin2(BrowserStyle.zero, BrowserStyle.Spacing.xSmall),
          tl: {
            hd: BrowserStyle.mobileMedia(BrowserStyle.withFont(undefined, undefined, /* XLarge */5, undefined)({
                      hd: BrowserStyle.textAlign("center"),
                      tl: {
                        hd: BrowserStyle.display("block"),
                        tl: {
                          hd: BrowserStyle.margin2(BrowserStyle.Spacing.xSmall, BrowserStyle.zero),
                          tl: /* [] */0
                        }
                      }
                    })),
            tl: /* [] */0
          }
        }));

var Styles$2 = {
  selector: selector
};

function WebContainers_PostAShift_ShiftType$ShiftTypeButton(Props) {
  var onMouseEnter = Props.onMouseEnter;
  var onMouseLeave = Props.onMouseLeave;
  var shiftType = Props.shiftType;
  var shiftTypeSelected = Props.shiftTypeSelected;
  var updateSelectedShiftType = Props.updateSelectedShiftType;
  var shiftTypeId = shiftType.id;
  return React.createElement(BrowserComponents_Button.Selector.make, {
              className: selector,
              children: React.createElement(BrowserComponents_Text.make, {
                    children: shiftType.name
                  }),
              isSelected: Relude_Option.fold(false, (function (param) {
                      return Curry._2(CommonTypes_ShiftType.Id.eq, param.id, shiftTypeId);
                    }), shiftTypeSelected),
              onClick: (function (param) {
                  return Curry._1(updateSelectedShiftType, Relude_Option.pure(shiftType));
                }),
              onMouseEnter: Curry._1(onMouseEnter, shiftType),
              onMouseLeave: onMouseLeave,
              testId: "ShiftType-" + shiftType.name
            });
}

var ShiftTypeButton = {
  Styles: Styles$2,
  make: WebContainers_PostAShift_ShiftType$ShiftTypeButton
};

var selector$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.flexBasis(BrowserStyle.rem(10.0)),
      tl: {
        hd: BrowserStyle.margin2(BrowserStyle.zero, BrowserStyle.Spacing.xSmall),
        tl: {
          hd: BrowserStyle.mobileMedia({
                hd: BrowserStyle.flex({
                      NAME: "num",
                      VAL: 1.0
                    }),
                tl: {
                  hd: BrowserStyle.margin2(BrowserStyle.Spacing.xSmall, BrowserStyle.zero),
                  tl: /* [] */0
                }
              }),
          tl: /* [] */0
        }
      }
    });

var container$1 = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.paddingLeft(BrowserStyle.Spacing.xLarge),
      tl: {
        hd: BrowserStyle.paddingRight(BrowserStyle.Spacing.xLarge),
        tl: /* [] */0
      }
    });

var innerContainer = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.alignItems(BrowserStyle.center),
      tl: {
        hd: BrowserStyle.mobileMedia({
              hd: BrowserStyle.flexDirection(BrowserStyle.row),
              tl: /* [] */0
            }),
        tl: /* [] */0
      }
    });

function arg$2(param, param$1) {
  return BrowserStyle.withFont(param, param$1, /* Large */4, /* Bold */2);
}

var name = Curry._1(BrowserStyle.style, {
      hd: BrowserStyle.mobileMedia(Curry._1(arg$2(undefined, undefined), {
                hd: BrowserStyle.marginLeft(BrowserStyle.Spacing.small),
                tl: /* [] */0
              })),
      tl: /* [] */0
    });

var Styles$3 = {
  selector: selector$1,
  container: container$1,
  innerContainer: innerContainer,
  name: name
};

function WebContainers_PostAShift_ShiftType$ShiftTypeCategoryButton(Props) {
  var isSelected = Props.isSelected;
  var onCategoryMouseEnter = Props.onCategoryMouseEnter;
  var onCategoryMouseLeave = Props.onCategoryMouseLeave;
  var setSelectedCategory = Props.setSelectedCategory;
  var shiftTypeCategory = Props.shiftTypeCategory;
  var name$1 = shiftTypeCategory.name;
  return React.createElement(BrowserComponents_Button.Selector.make, {
              className: selector$1,
              children: React.createElement(BrowserComponents_FlexColumn.make, {
                    className: innerContainer,
                    children: null
                  }, React.createElement(BrowserComponents_Icon.make, {
                        icon: {
                          TAG: /* Large */0,
                          _0: {
                            TAG: /* ShiftTypeCategory */2,
                            _0: shiftTypeCategory
                          }
                        },
                        size: /* XXLarge */5
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Small */3
                      }), React.createElement(BrowserComponents_Text.make, {
                        className: name,
                        children: name$1
                      })),
              containerClassName: container$1,
              isSelected: isSelected,
              onClick: (function (param) {
                  return Curry._1(setSelectedCategory, Relude_Option.pure(shiftTypeCategory));
                }),
              onMouseEnter: Curry._1(onCategoryMouseEnter, shiftTypeCategory),
              onMouseLeave: onCategoryMouseLeave,
              testId: "Category-" + name$1
            });
}

var ShiftTypeCategoryButton = {
  Styles: Styles$3,
  make: WebContainers_PostAShift_ShiftType$ShiftTypeCategoryButton
};

var ShiftTypeByCategoryIdMap = Relude_Map.WithOrd({
      eq: CommonTypes_ShiftType_Category.eq,
      compare: CommonTypes_ShiftType_Category.compare
    });

var partial_arg = Curry._1(ShiftTypeByCategoryIdMap.groupArrayBy, (function (param) {
        return param.category;
      }));

function sortAndFilterCategoriesForDisplay(param) {
  return Relude_Globals.$great$great(partial_arg, ShiftTypeByCategoryIdMap.keyArray, param);
}

var partial_arg$1 = Curry._1(ShiftTypeByCategoryIdMap.groupArrayBy, (function (param) {
        return param.category;
      }));

function sortAndFilterShiftsForDisplay(param) {
  return Relude_Globals.$great$great(partial_arg$1, ShiftTypeByCategoryIdMap.toArray, param);
}

function getShiftTypeValidationMessage(rowIndex) {
  var partial_arg = rowIndex === 0;
  var partial_arg$1 = Relude_Option.filter(function (param) {
        return Relude_Globals.$$const(partial_arg, param);
      });
  var partial_arg$2 = Curry._1(Relude_Option.flatMap, Relude_Result.getError);
  return function (param) {
    return Relude_Globals.$great$great(partial_arg$2, partial_arg$1, param);
  };
}

function getShiftTypeButtonSelectedMessage(catId) {
  var partial_arg = Relude_Option.filter(function (param) {
        return Curry._2(CommonTypes_ShiftType_Category.Id.eq, param.category.id, catId);
      });
  return function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (param) {
                  return Relude_Option.map((function (param) {
                                return param.description;
                              }), param);
                }), param);
  };
}

function getShiftTypeButtonHoveredMessage(catId) {
  var partial_arg = Relude_Option.filter(function (param) {
        return Curry._2(CommonTypes_ShiftType_Category.Id.eq, param.category.id, catId);
      });
  return function (param) {
    return Relude_Globals.$great$great(partial_arg, (function (param) {
                  return Relude_Option.map((function (param) {
                                return param.description;
                              }), param);
                }), param);
  };
}

function getValidationOrShiftTypeMessage(shiftTypeResult, rowIndex, catId, buttonHovered, buttonSelected) {
  return Curry._2(Relude_Option.Infix.$less$pipe$great, Curry._2(Relude_Option.Infix.$less$pipe$great, getShiftTypeButtonSelectedMessage(catId)(buttonSelected), getShiftTypeButtonHoveredMessage(catId)(buttonHovered)), getShiftTypeValidationMessage(rowIndex)(shiftTypeResult));
}

function getIsValidationMessage(shiftTypeResult, rowIndex, catId, buttonHovered) {
  var match = getShiftTypeButtonHoveredMessage(catId)(buttonHovered);
  var match$1 = getShiftTypeValidationMessage(rowIndex)(shiftTypeResult);
  if (match !== undefined) {
    return false;
  } else {
    return match$1 !== undefined;
  }
}

function getRequestedWorkersForShiftType(param) {
  var selectedShiftTypeId = param.id;
  return Reselect.createSelector1(undefined, Relude_Globals.id, (function (param) {
                return Relude_Globals.$great$great((function (param) {
                              return Relude_Globals.$great$great(Relude_Set.toArray, (function (param) {
                                            return Relude_Array.filter((function (param) {
                                                          return Curry._2(CommonTypes_ShiftType.Id.eq, selectedShiftTypeId, param.shiftTypeId);
                                                        }), param);
                                          }), param);
                            }), (function (param) {
                              return Relude_Array.sortBy(CommonTypes_Business_RequestableWorker.compareByName, param);
                            }), param);
              }));
}

function WebContainers_PostAShift_ShiftType(Props) {
  var enableRequestedWorkers = Props.enableRequestedWorkers;
  var fetchMinHourlyRate = Props.fetchMinHourlyRate;
  var goBack = Props.goBack;
  var markupRate = Props.markupRate;
  var param = Props.newShift;
  var requestableWorkers = Props.requestableWorkers;
  var setBasicInfo = Props.setBasicInfo;
  var shiftTypes = Props.shiftTypes;
  var tipsPaidByQwickMarkup = Props.tipsPaidByQwickMarkup;
  var basicInfo = param.basicInfo;
  var match = ReactIO.useMappableState(function (param) {
        return Relude_Option.fold(CommonTypes_Business_RequestableWorker.$$Set.empty, (function (param) {
                      return param.requestedWorkers;
                    }), basicInfo);
      });
  var setSelectedRequestedWorkers = match[1];
  var selectedRequestedWorkers = match[0];
  var match$1 = ReactIO.useState(function (param) {
        return false;
      });
  var setRequestedWorkersModalVisible = match$1[1];
  var match$2 = ReactIO.useState(function (param) {
        
      });
  var setAverageRateModal = match$2[1];
  var match$3 = ReactIO.useState(function (param) {
        
      });
  var setTypeButtonHovered = match$3[1];
  var typeButtonHovered = match$3[0];
  var onTypeMouseEnter = function (param) {
    return Relude_Globals.$great$great(Relude_Option.pure, setTypeButtonHovered, param);
  };
  var onTypeMouseLeave = Curry._1(setTypeButtonHovered, undefined);
  var match$4 = ReactIO.useState(function (param) {
        return Relude_Option.map((function (param) {
                      return param.shiftType.category;
                    }), basicInfo);
      });
  var setSelectedCategory = match$4[1];
  var selectedCategory = match$4[0];
  var match$5 = ReactIO.useState(function (param) {
        
      });
  var setHoveredCategory = match$5[1];
  var onCategoryMouseEnter = function (param) {
    return Relude_Globals.$great$great(Relude_Option.pure, setHoveredCategory, param);
  };
  var onCategoryMouseLeave = Curry._1(setHoveredCategory, undefined);
  var displayedCategory = Relude_Option.alt(match$5[0], selectedCategory);
  var match$6 = useForm(initialInput(basicInfo), {
        fetchMinHourlyRate: fetchMinHourlyRate
      }, (function (output, param) {
          var notifyOnFailure = param.notifyOnFailure;
          var shiftType = output.selectedShiftType;
          var match = output.hourlyRate;
          var averageRateCents = match.averageRateCents;
          return IOUtils.unsafeRunHandledAsync(Relude_IO.flatMap((function (hourlyRateOk) {
                            if (hourlyRateOk) {
                              return Curry._1(setBasicInfo, toNewShiftBasicInfo(selectedRequestedWorkers, output));
                            } else {
                              return Relude_IO.suspend(function (param) {
                                          return Curry._1(notifyOnFailure, /* RateNeedsAdjusting */0);
                                        });
                            }
                          }), Curry._2(Relude_Int.OrdNamed.greaterThanOrEq, averageRateCents, Relude_Float.roundAsInt(100.0 * match.hourlyRate)) ? Relude_IO.pure(true) : Relude_IO.async(function (onResult) {
                                return IOUtils.unsafeRunHandledAsync(Curry._1(setAverageRateModal, Relude_Option.pure({
                                                    averageRateCents: averageRateCents,
                                                    onClose: (function (okWithLowRate) {
                                                        return Relude_IO.map((function (param) {
                                                                      return Curry._1(onResult, Relude_Result.ok(okWithLowRate));
                                                                    }), Curry._1(setAverageRateModal, undefined));
                                                      }),
                                                    shiftType: shiftType
                                                  })));
                              })));
        }));
  var submit = match$6.submit;
  var match$7 = match$6.input;
  var selectedShiftType = match$7.selectedShiftType;
  var hourlyRate = match$7.hourlyRate;
  var selectedShiftTypeResult = match$6.selectedShiftTypeResult;
  var updateHourlyRate = match$6.updateHourlyRate;
  var updateNumberOfWorkers = match$6.updateNumberOfWorkers;
  var updateSelectedShiftType = match$6.updateSelectedShiftType;
  var updateTipsPayoutType = match$6.updateTipsPayoutType;
  var blurHourlyRate = Relude_IO.suspend(match$6.blurHourlyRate);
  var updateHourlyRate$1 = function (hourlyRate) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateHourlyRate, (function (input, hourlyRate) {
                              return {
                                      hourlyRate: hourlyRate,
                                      numberOfWorkers: input.numberOfWorkers,
                                      selectedShiftType: input.selectedShiftType,
                                      tipsPayoutType: input.tipsPayoutType
                                    };
                            }), hourlyRate);
              });
  };
  var updateNumberOfWorkers$1 = function (numberOfWorkers) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateNumberOfWorkers, (function (input, numberOfWorkers) {
                              return {
                                      hourlyRate: input.hourlyRate,
                                      numberOfWorkers: numberOfWorkers,
                                      selectedShiftType: input.selectedShiftType,
                                      tipsPayoutType: input.tipsPayoutType
                                    };
                            }), numberOfWorkers);
              });
  };
  var updateSelectedShiftType$1 = function (selectedShiftType) {
    return Relude_IO.flatMap((function (param) {
                  return Curry._1(setSelectedRequestedWorkers, (function (param) {
                                return Relude_Globals.$$const(CommonTypes_Business_RequestableWorker.$$Set.empty, param);
                              }));
                }), Relude_IO.flatMap((function (param) {
                      return Relude_Option.fold(Relude_IO.pure(undefined), updateHourlyRate$1, Relude_String.toNonEmpty(hourlyRate));
                    }), Relude_IO.suspend(function (param) {
                        return Curry._2(updateSelectedShiftType, (function (input, selectedShiftType) {
                                      return {
                                              hourlyRate: input.hourlyRate,
                                              numberOfWorkers: input.numberOfWorkers,
                                              selectedShiftType: selectedShiftType,
                                              tipsPayoutType: input.tipsPayoutType
                                            };
                                    }), selectedShiftType);
                      })));
  };
  var updateTipsPayoutType$1 = function (tipsPayoutType) {
    return Relude_IO.suspend(function (param) {
                return Curry._2(updateTipsPayoutType, (function (input, tipsPayoutType) {
                              return {
                                      hourlyRate: input.hourlyRate,
                                      numberOfWorkers: input.numberOfWorkers,
                                      selectedShiftType: input.selectedShiftType,
                                      tipsPayoutType: tipsPayoutType
                                    };
                            }), tipsPayoutType);
              });
  };
  var onSubmit = Relude_IO.suspend(function (param) {
        return Curry._1(submit, undefined);
      });
  ReactIO.useHandledIOOnMount(undefined)(DomUtils.$$Window.scrollToTop);
  var partial_arg = Relude_IO.pure(undefined);
  ReactIO.useEffect0(undefined, undefined, Relude_IO.flatMap((function (param) {
              return Relude_Option.fold(partial_arg, (function (param) {
                            return Relude_Globals.$great$great((function (param) {
                                          return Relude_Globals.$$const(hourlyRate, param);
                                        }), updateHourlyRate$1, param);
                          }), param);
            }), Relude_IO.pure(Relude_Float.fromString(hourlyRate))));
  var requestableWorkersForShiftType = Relude_Option.fold([], (function (shiftType) {
          return getRequestedWorkersForShiftType(shiftType)(requestableWorkers);
        }), selectedShiftType);
  var tmp;
  if (Relude_Option.isSome(selectedShiftType)) {
    var partial_arg$1 = Relude_IO.pure(undefined);
    var tmp$1 = {
      markupRate: markupRate,
      onChangeRate: (function (param) {
          return Relude_Option.fold(partial_arg$1, (function (param) {
                        return Relude_Globals.$great$great(Relude_IO.pure, (function (param) {
                                      return Relude_IO.flatMap((function (param) {
                                                    return Relude_Globals.$great$great(Relude_Float.toString, updateHourlyRate$1, param);
                                                  }), param);
                                    }), param);
                      }), param);
        }),
      onChangeTipsPayoutType: updateTipsPayoutType$1,
      onBlur: blurHourlyRate,
      testId: "HourlyRateInput",
      tipsPaidByQwickMarkup: tipsPaidByQwickMarkup,
      tipsPayoutType: match$7.tipsPayoutType,
      tipsPayoutTypeResult: match$6.tipsPayoutTypeResult
    };
    var tmp$2 = Relude_Float.fromString(hourlyRate);
    if (tmp$2 !== undefined) {
      tmp$1.hourlyRate = Caml_option.valFromOption(tmp$2);
    }
    tmp = React.createElement(React.Fragment, undefined, React.createElement(WebComponents_PostAShiftForm.Title.make, {
              subtitle: "Whether you need one Professional or fifty, we've got you covered",
              title: "Number of " + (Relude_Option.fold("Professional", (function (param) {
                        return param.name;
                      }), selectedShiftType) + "s")
            }), React.createElement(BrowserComponents_Counter.make, {
              className: counter,
              max: 999,
              min: 1,
              initialCount: match$7.numberOfWorkers,
              onUpdate: updateNumberOfWorkers$1,
              testId: "NumberOfWorkers"
            }), enableRequestedWorkers && Relude_Array.isNotEmpty(requestableWorkersForShiftType) ? React.createElement(React.Fragment, undefined, React.createElement(BrowserComponents_Spacer.make, {
                    size: /* Medium */4
                  }), React.createElement(BrowserComponents_Button.make, {
                    actionPriority: /* LegacyTertiary */3,
                    className: requestProfessionalsButton,
                    iconLeft: {
                      TAG: /* Messaging */3,
                      _0: /* Comment */1
                    },
                    onClick: (function (param) {
                        return Curry._1(setRequestedWorkersModalVisible, true);
                      }),
                    size: /* Small */0,
                    title: "Request Specific Professionals"
                  })) : null, React.createElement(BrowserComponents_Spacer.make, {
              size: /* XXLarge */7
            }), React.createElement(WebComponents_PostAShiftForm.Title.make, {
              subtitle: "Enter the hourly rate per worker",
              title: "Hourly Rate"
            }), React.createElement(WebContainers_PostAShift_ShiftType$HourlyRate, tmp$1));
  } else {
    tmp = null;
  }
  return React.createElement(WebComponents_PostAShiftForm.make, {
              children: null,
              onBackButtonClick: goBack,
              onSubmit: onSubmit,
              overrideContainerWidthPercent: 65.0,
              submitButtonDisabled: Relude_Option.isNone(selectedShiftType),
              subtitle: "We have 20+ different types of pre-certified Professionals ready to make your event a success.",
              testIdPrefix: "",
              title: "Shift Type"
            }, React.createElement(BrowserComponents_FlexRow.make, {
                  className: shiftCategoriesButtonContainer,
                  children: React.createElement(ReactUtils.A.make, {
                        children: Relude_Array.mapWithIndex((function (param, param$1) {
                                var shiftTypeCategory = param[0];
                                return React.createElement(WebContainers_PostAShift_ShiftType$ShiftTypeCategoryButton, {
                                            isSelected: Relude_Option.fold(false, (function (selectedCategory) {
                                                    return CommonTypes_ShiftType_Category.eq(selectedCategory, shiftTypeCategory);
                                                  }), selectedCategory),
                                            onCategoryMouseEnter: onCategoryMouseEnter,
                                            onCategoryMouseLeave: onCategoryMouseLeave,
                                            setSelectedCategory: setSelectedCategory,
                                            shiftTypeCategory: shiftTypeCategory,
                                            key: Curry._1(CommonTypes_ShiftType_Category.Id.toString, shiftTypeCategory.id)
                                          });
                              }), sortAndFilterShiftsForDisplay(shiftTypes))
                      })
                }), Relude_Array.mapWithIndex((function (param, rowIndex) {
                    var category = param[0];
                    var categoryId = category.id;
                    if (Relude_Option.fold(false, (function (param) {
                              return CommonTypes_ShiftType_Category.eq(category, param);
                            }), displayedCategory)) {
                      return React.createElement(React.Fragment, {
                                  children: null,
                                  key: Curry._1(CommonTypes_ShiftType_Category.Id.toString, categoryId)
                                }, React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Medium */4
                                    }), React.createElement(BrowserComponents_FlexRow.make, {
                                      className: shiftTypesButtonContainer,
                                      children: React.createElement(ReactUtils.A.make, {
                                            children: Curry._2(Relude_Array.map, (function (shiftType) {
                                                    return React.createElement(WebContainers_PostAShift_ShiftType$ShiftTypeButton, {
                                                                onMouseEnter: onTypeMouseEnter,
                                                                onMouseLeave: onTypeMouseLeave,
                                                                shiftType: shiftType,
                                                                shiftTypeSelected: selectedShiftType,
                                                                updateSelectedShiftType: updateSelectedShiftType$1,
                                                                key: Curry._1(CommonTypes_ShiftType.Id.toString, shiftType.id)
                                                              });
                                                  }), param[1])
                                          })
                                    }), React.createElement(BrowserComponents_Spacer.make, {
                                      size: /* Medium */4
                                    }), React.createElement(BrowserComponents_Subtext.make, {
                                      className: descText(getIsValidationMessage(selectedShiftTypeResult, rowIndex, categoryId, typeButtonHovered)),
                                      children: Relude_Option.getOrElse("", getValidationOrShiftTypeMessage(selectedShiftTypeResult, rowIndex, categoryId, typeButtonHovered, selectedShiftType))
                                    }));
                    } else {
                      return null;
                    }
                  }), sortAndFilterShiftsForDisplay(shiftTypes)), React.createElement(BrowserComponents_Spacer.make, {
                  size: /* XLarge */6
                }), tmp, React.createElement(BrowserComponents_ValidationError.make, {
                  className: error,
                  validationResult: Curry._2(Relude_Option.flatMap, (function (result) {
                          if (result.TAG === /* Validating */0) {
                            return ;
                          } else {
                            return Relude_Option.pure(result._0);
                          }
                        }), match$6.hourlyRateResult)
                }), match$1[0] ? React.createElement(BrowserComponents_Modal.Legacy.make, {
                    children: null
                  }, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                        title: "Request Specific Professionals"
                      }), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                        text: "The Professionals you see below have been rated 5 stars by your business in the past, and if selected will be the first to recieve an invite for your upcoming shift. Please note that this does not guarantee that these Professionals will be assigned to your shift."
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Large */5
                      }), React.createElement(BrowserComponents_FlexRow.make, {
                        className: professionalSelectSection,
                        children: Curry._2(Relude_Array.map, (function (requestableWorker) {
                                return React.createElement(BrowserComponents_Button.Selector.make, {
                                            className: professionalSelector,
                                            children: React.createElement(BrowserComponents_Text.make, {
                                                  children: requestableWorker.fullName
                                                }),
                                            isSelected: Curry._2(CommonTypes_Business_RequestableWorker.$$Set.contains, requestableWorker, selectedRequestedWorkers),
                                            onClick: (function (param) {
                                                return Curry._1(setSelectedRequestedWorkers, Curry._1(CommonTypes_Business_RequestableWorker.$$Set.toggle, requestableWorker));
                                              })
                                          });
                              }), requestableWorkersForShiftType)
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Large */5
                      }), React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* Primary */0,
                        onClick: (function (param) {
                            return Curry._1(setRequestedWorkersModalVisible, false);
                          }),
                        title: "Request Professionals"
                      }), React.createElement(BrowserComponents_Spacer.make, {
                        size: /* Small */3
                      }), React.createElement(BrowserComponents_Button.make, {
                        actionPriority: /* LegacySecondary */2,
                        onClick: (function (param) {
                            return Relude_IO.flatMap((function (param) {
                                          return Curry._1(setSelectedRequestedWorkers, (function (param) {
                                                        return Relude_Globals.$$const(CommonTypes_Business_RequestableWorker.$$Set.empty, param);
                                                      }));
                                        }), Curry._1(setRequestedWorkersModalVisible, false));
                          }),
                        title: "I Don't Need Anyone Specific"
                      })) : null, Relude_Option.fold(null, (function (param) {
                    var onClose = param.onClose;
                    return React.createElement(BrowserComponents_Modal.Legacy.make, {
                                children: null
                              }, React.createElement(BrowserComponents_FlexColumn.make, {
                                    className: lowRateHeader,
                                    children: null
                                  }, React.createElement(BrowserComponents_Modal.Legacy.TitleText.make, {
                                        title: "Low Rate Warning"
                                      }), React.createElement(BrowserComponents_Icon.make, {
                                        icon: {
                                          TAG: /* Small */1,
                                          _0: {
                                            TAG: /* Status */8,
                                            _0: /* AlertTriangle */1
                                          }
                                        },
                                        size: /* XLarge */4
                                      })), React.createElement(BrowserComponents_Modal.Legacy.$$Text.make, {
                                    text: "We are seeing shifts posted at " + (MathUtils.formatCentsToMoney(param.averageRateCents) + (" an hour for " + (param.shiftType.name + "s right now. We recommend increasing the rate for a higher likelihood this gets filled.")))
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Large */5
                                  }), React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* Primary */0,
                                    onClick: (function (param) {
                                        return Curry._1(onClose, false);
                                      }),
                                    title: "Adjust Rate"
                                  }), React.createElement(BrowserComponents_Spacer.make, {
                                    size: /* Small */3
                                  }), React.createElement(BrowserComponents_Button.make, {
                                    actionPriority: /* LegacySecondary */2,
                                    onClick: (function (param) {
                                        return Curry._1(onClose, true);
                                      }),
                                    title: "Continue Posting"
                                  }));
                  }), match$2[0]));
}

var make = WebContainers_PostAShift_ShiftType;

exports.ResultWithStringError = ResultWithStringError;
exports.HourlyRate = HourlyRate;
exports.Styles = Styles$1;
exports.FormFields = FormFields;
exports.ShiftTypeButton = ShiftTypeButton;
exports.ShiftTypeCategoryButton = ShiftTypeCategoryButton;
exports.ShiftTypeByCategoryIdMap = ShiftTypeByCategoryIdMap;
exports.sortAndFilterCategoriesForDisplay = sortAndFilterCategoriesForDisplay;
exports.sortAndFilterShiftsForDisplay = sortAndFilterShiftsForDisplay;
exports.getShiftTypeValidationMessage = getShiftTypeValidationMessage;
exports.getShiftTypeButtonSelectedMessage = getShiftTypeButtonSelectedMessage;
exports.getShiftTypeButtonHoveredMessage = getShiftTypeButtonHoveredMessage;
exports.getValidationOrShiftTypeMessage = getValidationOrShiftTypeMessage;
exports.getIsValidationMessage = getIsValidationMessage;
exports.getRequestedWorkersForShiftType = getRequestedWorkersForShiftType;
exports.make = make;
/* ResultWithStringError Not a pure module */
